var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingRedeem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#CD7F32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1465 10.4727L10.2857 9.54236V5.19428C10.2857 4.85329 10.1503 4.52626 9.90915 4.28515C9.66803 4.04403 9.341 3.90857 9.00001 3.90857C8.65902 3.90857 8.33199 4.04403 8.09087 4.28515C7.84975 4.52626 7.71429 4.85329 7.71429 5.19428V10.3371C7.71424 10.5759 7.7807 10.81 7.90622 11.0132C8.03174 11.2163 8.21136 11.3805 8.42495 11.4873L10.9964 12.773C11.3013 12.9245 11.6539 12.949 11.9768 12.8409C12.2997 12.7328 12.5665 12.5011 12.7188 12.1966C12.8711 11.892 12.8964 11.5395 12.7891 11.2163C12.6818 10.8932 12.4507 10.6257 12.1465 10.4727Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingRedeem);
export default __webpack_public_path__ + "static/media/pendingRedeem.31bf2f902fe792f46ab6ad21d722a177.svg";
export { ForwardRef as ReactComponent };